import React from "react";

function WameedhSupport() {
  return (
    <div className="bg-[#fffbf5] text-[#022934] font-sans p-8 max-w-3xl mx-auto">
      <header className="text-center mb-8">
        <h1 className="text-3xl font-bold text-[#022934]">Support</h1>
      </header>
      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-[#f8476d] mb-4">
          Contact Us
        </h2>
        <p className="text-lg leading-relaxed mb-4">
          If you need any assistance or have any questions about our game
          Wameedh, please feel free to reach out to us. We are here to help!
        </p>
        <p className="text-lg leading-relaxed">
          You can contact us via email at:
          <a href="mailto:tarbaa.kw@gmail.com" className="text-[#fea72c] ml-2">
            tarbaa.kw@gmail.com
          </a>
        </p>
      </section>
      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-[#f8476d] mb-4">
          Frequently Asked Questions
        </h2>
        <div className="mb-4">
          <h3 className="text-xl font-semibold text-[#022934]">
            1. How do I play Wameedh?
          </h3>
          <p className="text-lg leading-relaxed">
            Wameedh is a truth or dare game that you can play offline. Simply
            start the game, choose your difficulty level, and follow the prompts
            for each truth or dare challenge.
          </p>
        </div>
        <div className="mb-4">
          <h3 className="text-xl font-semibold text-[#022934]">
            2. Is my data safe?
          </h3>
          <p className="text-lg leading-relaxed">
            Yes, Wameedh is a fully offline game and does not collect any
            personal data. For more details, please refer to our Privacy Policy.
          </p>
        </div>
        <div className="mb-4">
          <h3 className="text-xl font-semibold text-[#022934]">
            3. How do I report a bug?
          </h3>
          <p className="text-lg leading-relaxed">
            If you encounter any issues or bugs while using Wameedh, please send
            a detailed email to
            <a
              href="mailto:tarbaa.kw@gmail.com"
              className="text-[#fea72c] ml-2"
            >
              tarbaa.kw@gmail.com
            </a>
            . Include as much information as possible so we can help resolve the
            issue.
          </p>
        </div>
      </section>
      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-[#f8476d] mb-4">Feedback</h2>
        <p className="text-lg leading-relaxed">
          We value your feedback and suggestions to improve Wameedh. Feel free
          to reach out to us at
          <a href="mailto:tarbaa.kw@gmail.com" className="text-[#fea72c] ml-2">
            tarbaa.kw@gmail.com
          </a>
          with any comments or ideas.
        </p>
      </section>
    </div>
  );
}

export default WameedhSupport;
